<script>
import { cloneDeep } from 'lodash-es';
import ItineraryPricesDefaultObjects from '../../../variables/itineraryPrices/itineraryPricesDefaultObjects';
import ItineraryPricesPriceSelectorMinorPax from '../itineraryPrices/ItineraryPricesPriceSelectorMinorPax';

export default {
  name: 'ItineraryPricesPriceSelector',
  components: { ItineraryPricesPriceSelectorMinorPax },
  props: {
    grossPrice: {
      type: Object,
      default: () => {},
    },
    priceSetting: {
      type: Object,
      default: () => {},
    },
    syncing: {
      type: Boolean,
      required: true,
    },
    validParticipantsAmounts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      priceTextPlaceholder: 'X adults & X children max. X',
      localGrossPrice: null,
      actionDisabled: false,
    };
  },
  created() {
    this.localGrossPrice = this.grossPrice
      ? cloneDeep(this.grossPrice)
      : cloneDeep(ItineraryPricesDefaultObjects.DEFAULT_GROSS_PRICE);
  },
  watch: {
    grossPrice: {
      deep: true,
      handler(value) {
        this.localGrossPrice = cloneDeep(value);
      },
    },
  },
  computed: {
    priceText() {
      const children = [];
      const adults = [];
      const seniors = [];
      if (this.localGrossPrice.ages.length) {
        // Find children and adults.
        this.localGrossPrice.ages.forEach((age) => {
          if (age < 40) {
            children.push(age);
          } else if (age === 40) {
            adults.push(age);
          } else {
            seniors.push(age);
          }
        });

        // Generate child text i.e "& 2 children"
        const uniqChildAges = [...new Set(children)].join(' & ');
        const childrenText = `& ${children.length} children - ${uniqChildAges} years old`;

        return adults.length
          ? `${adults.length} adults ${childrenText}`
          : `${seniors.length} senior ${childrenText}`;
      }
      return '';
    },
  },
  methods: {
    calculatePrice(updateMatrixPrices) {
      if (!this.localGrossPrice.index) {
        this.localGrossPrice.index = null;
      }
      this.$emit('sync', { grossPrice: this.localGrossPrice, updateMatrixPrices });
    },
    validateAmount(value) {
      this.actionDisabled = this.validParticipantsAmounts.includes(+value);
      if (this.validParticipantsAmounts.includes(+value)) {
        return true;
      }
      return 'NOT VALID';
    },
    validateIndex(value) {
      this.actionDisabled = this.validParticipantsAmounts.includes(+value) || value === '';
      if (this.validParticipantsAmounts.includes(+value) || !value) {
        return true;
      }
      return 'NOT VALID';
    },
    setMinorPaxAges(children) {
      const adults = this.localGrossPrice.ages.filter(age => age >= 40);
      this.localGrossPrice.ages = [...adults, ...children];
    },
    setAmountOfAdults(value) {
      const ages = this.localGrossPrice.ages.filter(age => age !== 40);
      for (let i = 0; i < value; i++) {
        ages.push(40);
      }
      this.localGrossPrice.ages = ages;
    },
  },
};
</script>

<template>
  <v-layout row>
    <v-flex xs3 mr-1>
      <v-text-field
        :placeholder="priceTextPlaceholder"
        :value="priceText"
        label="Price for"
        disabled
        box
        hide-details
      />
    </v-flex>
    <v-flex xs1 mr-1>
      <v-text-field
        v-model.number="localGrossPrice.index"
        :rules="[validateIndex]"
        label="Calc on fixed pax"
        placeholder="Fixed pax"
        box
        hide-details
      />
    </v-flex>
    <v-flex xs1 mr-1>
      <v-text-field
        :value="localGrossPrice.ages.filter(age => age === 40).length"
        :rules="[validateAmount]"
        placeholder="Adults"
        label="Adults"
        box
        hide-details
        @input="setAmountOfAdults"
      />
    </v-flex>
    <v-flex xs1>
      <v-text-field
        placeholder="Seniors"
        label="Seniors"
        disabled
        box
        hide-details
      />
    </v-flex>
    <v-flex xs1 mr-1>
      <itinerary-prices-price-selector-minor-pax
        :discounts="priceSetting.hotels[0].setting.discounts"
        :child-ages="localGrossPrice.ages.filter(age => age < 40)"
        @update="setMinorPaxAges"
      />
    </v-flex>
    <v-flex xs1 mr-1 class="text-xs-center">
      <v-btn
        :disabled="!actionDisabled"
        :loading="syncing"
        class="mt-2"
        color="primary"
        hide-details
        @click="calculatePrice(true)"
      >
        Calc <v-icon right dark>sync_alt</v-icon>
      </v-btn>
    </v-flex>
    <v-divider class="mx-3" vertical />
    <v-flex xs1 mr-1>
      <v-text-field
        label="Calculated price"
        :value="localGrossPrice.calculatedPrice"
        disabled
        box
        hide-details
      />
    </v-flex>
    <v-flex xs1 mr-1>
      <v-text-field
        v-model="localGrossPrice.price"
        label="Web price"
        box
        hide-details
      />
    </v-flex>
    <v-flex class="text-xs-center">
      <v-btn
        :disabled="!actionDisabled"
        class="mt-2"
        color="success"
        @click="calculatePrice(false)"
      >
        Save web price
      </v-btn>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSelector.vue